"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _layout = require("@berlitz/globals/lib/components/layout");
var _typography = require("@berlitz/globals/lib/components/typography");
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _levelChart = _interopRequireDefault(require("@berlitz/level-chart"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BlockLevelChart = function BlockLevelChart(_ref) {
  var _ref$alignCenterTitle = _ref.alignCenterTitle,
    alignCenterTitle = _ref$alignCenterTitle === void 0 ? false : _ref$alignCenterTitle,
    backgroundColor = _ref.backgroundColor,
    chartData = _ref.chartData,
    chartHelperLabel = _ref.chartHelperLabel,
    disablePaddingBottom = _ref.disablePaddingBottom,
    disablePaddingTop = _ref.disablePaddingTop,
    lockedLevel = _ref.lockedLevel,
    size = _ref.size,
    subtitle = _ref.subtitle,
    title = _ref.title;
  return /*#__PURE__*/_react.default.createElement(_layout.Section, {
    backgroundColor: backgroundColor,
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_typography.TextAlign, {
    align: alignCenterTitle ? 'center' : 'left'
  }, title && /*#__PURE__*/_react.default.createElement(_typography.H2, {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), subtitle && /*#__PURE__*/_react.default.createElement(_typography.P, {
    dangerouslySetInnerHTML: {
      __html: subtitle
    }
  }), /*#__PURE__*/_react.default.createElement(_spacer.default, null)), /*#__PURE__*/_react.default.createElement(_levelChart.default, {
    data: chartData,
    chartHelperLabel: chartHelperLabel,
    lockedLevel: lockedLevel
  })))));
};
BlockLevelChart.defaultProps = {
  size: 'lg'
};
var _default = BlockLevelChart;
exports.default = _default;